module.exports = __webpack_public_path__ + "img/max-office-building-search.9c74c7d5.svg";